import { Provider, useDispatch, useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { ToastContainer } from 'react-toastify';
import Navigator from './modules/navigator';

import '@material/react-snackbar/index.scss';
import './styles/main.scss';

import { RootState, store } from './store/store';
import { refreshToken } from './store/actions';
import { AuthService } from './modules/auth/authentication';

function App() {
  const themeName = useSelector((root: RootState) => root.app.themeName);
  const dispatch = useDispatch();
  if (AuthService.getRefreshToken()) {
    dispatch(refreshToken(AuthService.getRefreshToken() || ''));
  }

  return (
    <div className={'theme-' + themeName}>
      <svg style={{ display: 'none' }} xmlns="http://www.w3.org/2000/svg" version="1.1">
        <defs>
          <filter id="blur">
            <feGaussianBlur stdDeviation="3" />
          </filter>
        </defs>
      </svg>
      <Navigator />
    </div>
  );
}


const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={true}
    />
  </Provider>
);

reportWebVitals();
